<div class="table-responsive mb-3">
    <p class="text-center"> {{form.searchMessage}} </p>

    <!-- Success / error messages -->
    <p *ngIf="form['error'] == false && form['message']">
        <app-ncs-alert [message]="form['message']" type="success" />
    </p>
    <p *ngIf="form['error'] == true && form['message']">
        <app-ncs-alert [message]="form['message']" type="danger" />
    </p>
    
    <!-- Table or message based on view permission -->
    <ng-container *ngIf="canRead(); else noViewPermission">
        <app-table-row-editor
            [dataList]="form['list']"
            [activeColumns]="activeColumns"
            [dropdownOptions]="getDropdownOptions()"
            [columnLabels]="getColumnLabel()"
            (onSave)="handleSave($event)"
            (onUpdate)="handleUpdate($event)"
            (onDelete)="handleDelete($event)"
            [nonEditableColumns]="getNonEditableColumns()"
            [canAdd]="canCreate()"
            [canEdit]="canUpdate()"
            [canDelete]="canDelete()"
        >
        </app-table-row-editor>
    </ng-container>

    <!-- Message if no view permission -->
    <ng-template #noViewPermission>
        <div class="alert alert-warning text-center">
            {{ 'roleAccess.messages.noViewPermission' | translate }}
        </div>
    </ng-template>
</div>